import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { Fee } from '../../interfaces/fee';

export interface FeesQueryResponse {
  fees: {
    code: string;
    success: boolean;
    message: string;
    fees: Fee[];
    count: number;
  };
}

export interface FeesQueryParams {
  where: {
    accountUid: string;
  };
  limit?: number;
  offset?: number;
}

@Injectable({
  providedIn: 'root',
})
export class FeesGQL extends Query<FeesQueryResponse, FeesQueryParams> {
  document = gql(`
  query fees($where: ModelFeeFilterInput, $limit: Int, $offset: Int) {
    fees(where: $where, limit: $limit, offset: $offset) {
      code
      success
      message
      fees {
        uid
        title
        disclaimer
        amount_type
        amount
        amount_formula
        taxable_category
        criteriaCount
      }
      count
    }
  }
  `);
}
